exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yellow-bg{\r\n    background-color: lavenderblush;\r\n}\r\n.gold .codeColumn { background-color: yellow; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/holidays/holidays.component.css
// module id = ../../../../../src/app/hrms/holidays/holidays.component.css
// module chunks = main